// src/features/encounter/encounterSlice.ts
//       // ❷ 환자 정보 수정 API 호출
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit"
import { buhangcupSerializer } from "@/types/buhangcup"
import { fetchBuhangcups } from "@core/api/buhangcupApi"

interface buhangcupPayload {
  buhangcups: buhangcupSerializer[]
  loading: boolean
  error: string | null
}

const initialState: buhangcupPayload = {
  buhangcups: [],
  loading: false,
  error: null,
}

const buhangcupSlice = createSlice({
  name: "buhangcup",
  initialState,
  reducers: {
    clearBuhangcups(state) {
      state.buhangcups = []
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: builder => {
    builder
      // fetchPatients 관련 처리
      .addCase(fetchBuhangcups.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchBuhangcups.fulfilled, (state, action) => {
        state.loading = false
        state.buhangcups = action.payload
        // console.debug("부항컵 목록", action.payload)
        // console.debug("수가 목록", state.sugas)
      })
      .addCase(fetchBuhangcups.rejected, (state, action) => {
        state.loading = false
        state.buhangcups = []
        state.error = (action.payload as string) || action.error.message || "오류 "
      })
  },
})

export const { clearBuhangcups, setLoading, setError } = buhangcupSlice.actions

export default buhangcupSlice.reducer
